<template>

  <div v-if="colorTable === 'gradientColors'" class="text-center">
    <div style="font-size: 16px; margin-bottom: 5px;"><strong>Color Code</strong></div>
    <span  v-for="(level, index) in gradientColors">
      <v-chip :style="`background: ${gradientColors[index]}; color: ${getBrightness(gradientColors[index]) > 128 ? 'black' : 'white'} `" class="ma-2">
        {{ Utils.methods.getSuccessStrings(index) }}
      </v-chip>
    </span>
    <span v-if="averageScoreOption" class="average-score">
      <v-chip
          v-for="(item, index) in extraLegendItems"
          :style="`background: ${extraLegendItemColors[index] || extraLegendItemColors[0]}`"
          class="mr-2 text-white"
      >
        {{ item }}
      </v-chip>
    </span>
  </div>
  <div v-else class="average-scores-container">
    <div style="font-size: 15px; margin-bottom: 5px;">
      <strong>Final {{ averageType }} Scores per Aggregation Level
        <span v-if="showFinalSII">*</span>
      </strong>
    </div>
    <table>
      <thead>
        <tr>
          <th :class="`${level.toLowerCase()}-border px-5 pt-3 text-center`" v-for="(level) in activeLevels">{{ StringManipulation.methods.clearAndCapitalize(level) }} </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="px-5 text-center" v-for="(level) in activeLevels">{{ averageScores[level.toLowerCase()].toFixed(2) }} </td>
        </tr>
      </tbody>
    </table>
    <div v-if="showFinalSII" class="text-muted mx-1 mb-4" style="font-size: 12px; clear: both">
      *Darker lines represent the final {{ averageType }} score.
    </div>
  </div>
</template>

<!-- TODO: Complete the migration in this file -->
<script setup>
import Utils from "@/Mixins/Utils";
import {computed} from "vue";
import StringManipulation from "../../Mixins/StringManipulation";

const props = defineProps({

  activeLevels: {
    type: Array,
    required: false
  },
  averageScores: {
    type: Object,
    required: false
  },
  averageScoreOption: {
    type: Boolean,
    default: false,
    required: false
  },
  colors: {
    type: Array,
    required: false,
  },
  colorTable:
      {
        type: String,
        required: true
      },
  gradientColors: {
    type: Array,
    required: false
  },
  legendItemTitle: {
    type: String,
    required: false
  },
  extraLegendItems: {
    type: Array,
    required: false,
    default: () => {
      return []
    }
  },
  showFinalSII: {
    type: Boolean,
    default: false,
    required: false
  },
  isSpiOrSii: {
    type: String,
    required: false,
    default: 'sii'
  }
})
const averageType = computed(() => {
  if (props.isSpiOrSii === 'sii') return 'SII'
  else return 'SPI'
})

function getBrightness(color) {
  // Check if the color is in hexadecimal format
  if (color.startsWith('#')) {
    // Convert 3-digit hex to 6-digit hex
    if (color.length === 4) {
      color = '#' + color[1] + color[1] + color[2] + color[2] + color[3] + color[3];
    }
    // Extract RGB components
    const r = parseInt(color.slice(1, 3), 16);
    const g = parseInt(color.slice(3, 5), 16);
    const b = parseInt(color.slice(5, 7), 16);
    // Calculate brightness
    return (0.299 * r + 0.587 * g + 0.114 * b);
  }

  throw new Error('Invalid color format. Please use a hex color code.');
}

const extraLegendItemColors = ["#ff0000", "#ff8000", "#e45700"]

</script>

<style scoped>
  .peb-border {
    border-top: #2982ff solid 6px;
    column-gap: 400px;
    row-gap: 400px;
  }

  .ped-border {
    border-top: #07d107 solid 6px;
    column-gap: 20px;
  }

  .city-border {
    border-top: #ffb800 solid 6px;
    column-gap: 20px;
  }

  .building-border {
    border-top: #ff0019 solid 6px;
    column-gap: 20px;
  }

  .island-border {
    border-top: #a100ff solid 6px;
    column-gap: 20px;
  }

  thead {
    background: transparent;
  }

  table {
    border-spacing: 15px; /* Adjust spacing between table cells */
  }

</style>
